import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedWorkspaceApp from "./EmbeddedWorkspaceApp";
const ExternalLink = ({ href, children }) => /* @__PURE__ */ React.createElement("a", { href, rel: "noopener noreferrer", target: "_blank" }, children);
const WorkspaceApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("googleworkspace.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("googleworkspace.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "googleworkspace.app.requirements",
      components: {
        workspaceLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://workspace.google.com/" })
      }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedWorkspaceApp, null));
};
export default WorkspaceApp;
